var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.payingOrgs),function(orgId,index){return _c('span',{key:index},[_vm._v(" "+_vm._s(_vm.getSeparatorIfRequired(index))+" "),_c('span',{class:{'font-weight-bold': _vm.isCurrentOrg(orgId)}},[_vm._v(_vm._s(_vm.getName(orgId)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }